import { render, staticRenderFns } from "./RevisarReservaChapuzonView.vue?vue&type=template&id=59a03f9c&"
import script from "./RevisarReservaChapuzonView.vue?vue&type=script&lang=ts&"
export * from "./RevisarReservaChapuzonView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports